// @ts-ignore esModuleInterop
import React, { useState, useEffect } from 'react'
import { Text } from '@adc/ui-adc'
import type { GenericDate } from '@adc/sdk/types'
import {
  getAuctionDurationDisplayText,
  getTimezoneAbbreviation,
} from 'common/modules/bidBanner/auctionDuration/utils'

const AUCTION_DURATION_LABEL = 'Auction Duration'
export const Compact = ({
  endDateTime,
  fontWeight,
  startDateTime,
}: DurationProps) => (
  <>
    <Text as='span' color='gray' data-elm-id='auction_duration_label'>
      {`${AUCTION_DURATION_LABEL} `}
    </Text>
    <Duration
      endDateTime={endDateTime}
      fontWeight={fontWeight}
      startDateTime={startDateTime}
    />
  </>
)

interface DurationProps {
  endDateTime?: GenericDate | string | undefined
  fontWeight?: 'normal' | 'heavy' | 'medium' | 'black' | undefined
  startDateTime?: GenericDate | string | undefined
}

/**
 * This component uses client timezone. Render only on the client side.
 */
export const Duration = ({
  endDateTime = '',
  fontWeight = 'heavy',
  startDateTime = '',
}: DurationProps) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) return null

  const displayText = getAuctionDurationDisplayText(startDateTime, endDateTime)
  const timezoneAbbreviation = getTimezoneAbbreviation()

  return (
    <Text as='span' color='gray' weight={fontWeight}>
      <span data-elm-id='auction_duration_date_range'>{displayText}</span>
      &nbsp;
      <span data-elm-id='auction_duration_time_zone'>
        {timezoneAbbreviation}
      </span>
    </Text>
  )
}
